module.exports = {
  /**
   * Show select images dialog
   */
  getStringById: (id) => {
    const messages = [
      "core_missed_call_from",
      "core_user_left_conference",
      "core_invite_cancelled",
      "core_login_failed",
      "core_account_blocked",
      "core_data_update_failed",
      "core_contact_saved",
      "core_no_internet",
      "core_wrong_number",
      "core_invalid_email",
      "core_invalid_user",
      "core_token_register_failed",
      "core_cannot_download_file",
      "core_cannot_upload_large_file",
      "core_cannot_upload",
      "core_login_exists",
      "core_login_invalid",
      "core_weak_password",
      "core_registration_error",
      "core_authorization_error",
      "core_user_not_responding"
    ]
    return messages[id-1]
  }
}